import actionTypes from './actionTypes'

const paywallsActions = {
	notEnoughSpaceConfirmUpgradeSelected(intercomIsEnabled, upgradeSource) {
		return {
			type: actionTypes.PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM_UPGRADE_SELECTED,
			intercomIsEnabled,
			upgradeSource,
		}
	},
	notEnoughSpaceConfirmCloseSelected() {
		return {
			type: actionTypes.PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM_CLOSE_SELECTED,
		}
	},

	presentationSizeExceededConfirmAcceptSelected() {
		return {
			type: actionTypes.PAYWALLS_PRESENTATION_SIZE_EXCEEDED_CONFIRM_ACCEPT_SELECTED,
		}
	},

	presentationSizeExceededConfirmUpgradeSelected(upgradeSource) {
		return {
			type: actionTypes.PAYWALLS_PRESENTATION_SIZE_EXCEEDED_CONFIRM_UPGRADE_SELECTED,
			upgradeSource,
		}
	},

	presentationSizeExceededConfirmCloseSelected() {
		return {
			type: actionTypes.PAYWALLS_PRESENTATION_SIZE_EXCEEDED_CONFIRM_CLOSE_SELECTED,
		}
	},

	googleSlidesCreateAsUnauthorized(code) {
		return {
			type: actionTypes.PAYWALLS_CREATE_GOOGLE_SLIDES_UNAUTHORIZED,
			code,
		}
	},

	googleSlidesUnauthorizedCreateClose() {
		return {
			type: actionTypes.PAYWALLS_CREATE_GOOGLE_SLIDES_UNAUTHORIZED_CLOSE,
		}
	},

	googleSlidesEditAsUnauthorized() {
		return {
			type: actionTypes.PAYWALLS_EDIT_GOOGLE_SLIDES_UNAUTHORIZED,
		}
	},

	googleSlidesAddonUpgrade(code) {
		return {
			type: actionTypes.PAYWALLS_ADDON_GOOGLE_SLIDES_UPGRADE,
			code,
		}
	},

	googleSlidesUnauthorizedEditClose() {
		return {
			type: actionTypes.PAYWALLS_EDIT_GOOGLE_SLIDES_UNAUTHORIZED_CLOSE,
		}
	},
}

export default paywallsActions
